import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { LoadingNotification } from '@/components/ui/loading-notification';
import { AuthProvider } from '@/contexts/AuthContext';
import { LoadingProvider, useLoading } from '@/contexts/LoadingContext';
import { LoginForm } from '@/components/auth/LoginForm';
import { RegisterForm } from '@/components/auth/RegisterForm';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { Dashboard } from '@/components/Dashboard';

import { LocationProvider } from '@/contexts/LocationContext';
import { V2Provider } from '@/contexts/V2Context';
import { ForgotPasswordForm } from './components/auth/ForgotPasswordForm';
import { ResetPasswordForm } from './components/auth/ResetPasswordForm';

function AppContent() {
  const { loadingStates } = useLoading();
  const hasLoadingStates = loadingStates.length > 0;

  return (
    <>
      <Routes>
        <Route
          path='/login'
          element={
            <div className="min-h-screen w-full flex items-center justify-center">
              <LoginForm />
            </div>
          }
        />
        <Route
          path='/register'
          element={
            <div className="min-h-screen w-full flex items-center justify-center">
              <RegisterForm />
            </div>
          }
        />
        <Route path='/forgot-password' element={<ForgotPasswordForm />} />
        <Route path='/reset-password' element={<ResetPasswordForm />} />
        <Route
          path='/dashboard/*'
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path='/' element={<Navigate to='/dashboard' replace />} />
      </Routes>
      <Toaster />
      <LoadingNotification 
        isVisible={hasLoadingStates}
        loadingStates={loadingStates}
      />
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <LoadingProvider>
          <LocationProvider>
            <V2Provider>
              <AppContent />
            </V2Provider>
          </LocationProvider>
        </LoadingProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
